module.exports = __webpack_public_path__ + "img/fitbod_banner.4be9290a.jpg";